import React, { useCallback } from 'react';
import Navigation from '../components/navigation/navigation';
import i18n from '../../../utils/i18n';
import { withTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import TipsAndUpdatesIcon from '@mui/icons-material/TipsAndUpdates';
import { TextField } from '@mui/material';
import { useDispatch } from 'react-redux';
import ACTIONS from '../../../redux/action';

const Taxform = ({ ...props }) => {
	const companyStore = useSelector((state) => state.company_store);
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const [fullTimePartners, setFullTimePartners] = React.useState(
		companyStore.fullTimePartners || 0
	);
	const [partTimePartners, setPartTimePartners] = React.useState(
		companyStore.partTimePartners || 0
	);

	const handleNext = useCallback(
		(inc) => {
			props.handleNext(inc);
		},
		[props]
	);

	console.log(companyStore, 'companyStore');

	const handleBack = useCallback(
		(decr) => {
			props.handleBack(decr);
		},
		[props]
	);

	return (
		<div className="stepContainer">
			{companyStore.companytype === 'idk' ? (
				<div className="SFInput">
					<div className="SFWarningText">
						<TipsAndUpdatesIcon
							fontSize="medium"
							sx={{
								color: 'white',
								backgroundColor: '#1c32f3',
								px: 1.5,
								py: 0.75,
								borderRadius: 2,
								boxSizing: 'content-box',
							}}
						/>
						<p
							style={{
								fontWeight: '700',
								fontSize: '24px',
								color: '#4d5bec',
								margin: '20px 0',
							}}>
							{i18n.t('searchflow.vaflabel')}
						</p>
						<p
							style={{
								fontWeight: '700',
								fontSize: '16px',
								color: '#0b0f31',
								lineHeight: '24px',
								margin: '12px 0',
							}}>
							{i18n.t('searchflow.vafredirecttext')}
						</p>
						<p
							style={{
								fontWeight: '500',
								fontSize: '16px',
								lineHeight: '24px',
								color: '#333c45',
								margin: '12px 0',
							}}>
							{i18n.t('searchflow.vafredirecttext2')}
						</p>
						<p
							style={{
								fontWeight: '500',
								fontSize: '16px',
								lineHeight: '24px',
								color: '#333c45',
								margin: '12px 0',
							}}>
							{i18n.t('searchflow.vafredirecttext3')}
						</p>
					</div>
				</div>
			) : (
				<div className="SFInput">
					<p className="SFSubTitle">
						<span className="SFSubTitle">
							{i18n.t('searchflow.numberofpartners')}
						</span>{' '}
						<span className="questionTracker">2/8</span>
					</p>
					<p className="SFSubTitleHelper">
						{i18n.t('searchflow.numberoffulltimepartnersquestion')}
					</p>
					<div className="SFNameInput">
						<TextField
							className="SFNameInput"
							variant="outlined"
							id="fullTimePartners"
							type="number"
							name="fullTimePartners"
							value={fullTimePartners}
							onChange={(event) => {
								setFullTimePartners(event.target.value);
							}}
							onBlur={(event) => {
								dispatch(
									ACTIONS.addCompanyInfo({
										id: 'fullTimePartners',
										data: fullTimePartners,
										stateObject: 'company_store',
									})
								);
							}}
							label={i18n.t('searchflow.fulltimepartners')}
						/>
					</div>
					<hr />
					<p className="SFSubTitleHelper">
						{i18n.t('searchflow.numberofparttimepartnersquestion')}
					</p>
					<div className="SFNameInput">
						<TextField
							className="SFNameInput"
							variant="outlined"
							id="partTimePartners"
							type="number"
							name="partTimePartners"
							value={partTimePartners}
							onChange={(event) => {
								setPartTimePartners(event.target.value);
							}}
							onBlur={(event) => {
								dispatch(
									ACTIONS.addCompanyInfo({
										id: 'partTimePartners',
										data: partTimePartners,
										stateObject: 'company_store',
									})
								);
							}}
							label={i18n.t('searchflow.parttimepartners')}
						/>
					</div>
				</div>
			)}

			<Navigation
				step={2}
				handleBack={() => handleBack()}
				handleNext={() => {
					if (companyStore.companytype === 'idk') {
						companyStore.activeStep = 1;
						navigate('/company/request/vaf');
					} else {
						handleNext();
					}
				}}
				openHelpForm={() => props.openHelpForm()}
				disabledProp={false}
			/>
		</div>
	);
};

export default withTranslation()(Taxform);
